module.exports = __webpack_public_path__ + "fdb62d99613a5b5faa7e8fb64626f8e5.svg";